/**
 * @param {object} params
 * @param {import("../../../types/Post").Post} [params.post]
 * @returns {import("../../../types/Post").PostRevision | undefined} the `revision` or the `current_revision` of the post (or undefined)
 */
export function getPostPreferredRevision({ post }) {
  return post?.revision ?? post?.current_revision;
}
